export const UPDATE_PROFILE = 'Settings/UPDATE_PROFILE';
export const SET_SETTINGS_ERROR = 'Settings/SET_ERROR';
